import {
  Modal,
  Button,
  Box,
  Text,
  createStyles,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import swal from "sweetalert";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { editPayer, getpayer } from "../../services/payer";
import { stateZipCodes } from "../../utils/zipCodes";
import { IconChevronDown } from "@tabler/icons-react";
import { AddBillingProviderEnrollment, editProvider, getBillingProvider } from "../../services/billingprovider";

const useStyles = createStyles(() => ({
  mainbox: {
    background: " #F5F5F5",
    padding: "13px 19px",
  },
  addbox: {
    padding: "15px 13px 54px 13px",
    borderRadius: "16px",
    border: "1px solid #E5E5EA",
    background: "#FCFCFC",
  },

  width50: {
    width: "50%",
  },

  mainbtn: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
    marginTop: "46px",
    marginBottom: "78px",
  },

  widthbox: {
    width: "40%",
    "@media (max-width:1200px)": {
      width: "100%",
    },
  },

  formRow: {
    width: "100%",
    display: "flex",
    gap: "17px",
    marginBottom: "20px",
    marginTop: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },

    flexend: {
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  selectnumber: {
    width: "140px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    width: "min-content",
    // justifyContent:'flex-end'
  },
}));

const bgColor = "#FFFFFF";
const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",

      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#94A3B8"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

const ProviderEnrollment = ({
  EditProviderEnrollmentModalOpen,
  setEditProviderEnrollmentrModalOpen,
  item,
  isPreview,
}) => {
  // console.log('item',item);

  const { classes } = useStyles();

    const { allpayer } = useSelector((state) => state.payer);
      const { profile } = useSelector((state) => state?.profile);

    const [loading,setLoading]=useState(false)

const [iframeurl,setIFrameUrl]=useState(null)
 const [loaded, setLoaded] = useState(false);

 
  useEffect(() => {

    if (iframeurl){
    const timeout = setTimeout(() => {
      if (!loaded) {

        window.open(iframeurl, '_blank');
      }
    }, 6000); 

    return () => clearTimeout(timeout);
  }
  }, [loaded, iframeurl]);


  const form = useForm({
    initialValues: {
      prov_name_f: (item?.name || "").split(" ")[0] || "",
      prov_name_m: (item?.name || "").split(" ")[1] || "",
      prov_name_l: (item?.name || "").split(" ")[2] || "",
      payerid: "",
      prov_npi:
        item?.billingIdentifier?.type === "NPI"
          ? item?.billingIdentifier?.number
          : "",
      prov_id:
        item?.billingIdentifier?.type !== "NPI"
          ? item?.billingIdentifier?.number
          : "",

      prov_taxid: item?.federalTaxID?.number || "208655599",


      prov_addr_1: item?.address || "",
      prov_addr_2: item?.address2 || "",
      prov_city: item?.city || "",
      prov_state: item?.state || "",
      prov_zip: item?.zipcode || "",
    },
  });


  useEffect(()=>{
    getpayer()
    setIFrameUrl(null)
  },[])

  useEffect(() => {
    form.setValues({
      prov_name_f: (item?.name || "").split(" ")[0] || "",
      prov_name_m: (item?.name || "").split(" ")[1] || "",
      prov_name_l: (item?.name || "").split(" ")[2] || "",
      prov_npi:
        item?.billingIdentifier?.type === "NPI"
          ? item?.billingIdentifier?.number
          : "",
      prov_id:
        item?.billingIdentifier?.type !== "NPI"
          ? item?.billingIdentifier?.number
          : "",

    prov_taxid: item?.federalTaxID?.number || "208655599",
      prov_addr_1: item?.address || "",
      prov_addr_2: item?.address2 || "",
      prov_city: item?.city || "",
      prov_state: item?.state || "",
      prov_zip: item?.zipcode || "",
    });
  }, [item]);

  const onSave = async () => {



    let values = form.values;
    let missingFields = [];
    const optionalFields = [
      "prov_name_f",
      "prov_name_m",
      "prov_name_l",
      "prov_npi",
      "prov_id",
      "prov_addr_1",
      "prov_addr_2",
      "prov_city",
      "prov_state",
       "prov_zip",
    ];
    Object.entries(values)
      .filter(([key, _]) => !optionalFields.includes(key))
      .forEach(([key, value]) => !value && missingFields.push(key));

    if (missingFields.length > 0) {
      await swal({
        title: "Please fill out the following fields",
        text: missingFields.join(", "),
        icon: "warning",
        dangerMode: true,
      });
      return;
    }

    const selectedState = values.prov_state?.trim();
    const enteredZipCode = values.prov_zip?.trim();

    if (selectedState && enteredZipCode) {
      const stateZipCodeEntries = stateZipCodes.filter(
        (entry) => entry.ste_name === selectedState
      );

      const isZipValid = stateZipCodeEntries.some(
        (entry) => entry.zip_code === enteredZipCode
      );

      if (!isZipValid) {
        await swal({
          title: "Invalid Zip Code",
          text: `The zip code you entered is not valid for ${selectedState}. Please enter a valid zip code.`,
          icon: "warning",
          dangerMode: true,
        });
        return;
      }
    }



  const providerlast = values.prov_name_l?.trim();
    const providernpi = values.prov_npi?.trim();


    if (!providernpi && !providerlast){

           await swal({
          title: "MIssing Fields",
          text: `As Per Requirements atleast one things NPI Or Last name is required`,
          icon: "warning",
          dangerMode: true,
        });
      return;
    }

// setLoading(true)

let fullName = `${values.prov_name_f} ${values.prov_name_m} ${values.prov_name_l}`;

console.log('fullName',fullName);

console.log('item',item);
console.log('values',values);



if (
  item?.name.trim() !== fullName?.trim() ||
  item?.federalTaxID?.number !== values.prov_taxid ||
  item?.address  !== values?.prov_addr_1 ||
  item?.address2 !== values?.prov_addr_2 ||
  item?.city  !== values?.prov_city ||
  item?.state !== values?.prov_state ||
  item?.zipcode !== values?.prov_zip ||
  (item?.billingIdentifier?.type === 'NPI' && item?.billingIdentifier?.number !== values.prov_npi)
) {
  
  console.log('in the if');


      let newproviderpayload = {
          ...item,
          name:fullName,
        federalTaxID :{
          type:item?.federalTaxID?.type,
          number:values.prov_taxid
        }, 
          // billingIdentifier: {
          // type:item?.billingIdentifier?.type,
          //   number:  values.prov_npi,
          // },
    
    billingIdentifier: {
    type: item?.billingIdentifier?.type,
    number: item?.billingIdentifier?.type !== "NPI" 
      ? values.prov_npi 
      : item.prov_npi,
  },
          serviceCode: item?.serviceCode.id,
          facilityId:item?.facilityId.id,
          // admin: profile.user.id,
          // createdBy: profile?.user?.admin ?? profile?.user?.id,
          createdBy: profile.user.id,
        admin: profile?.user?.admin ?? profile?.user?.id,
          address  : values?.prov_addr_1, 
          address2 : values?.prov_addr_2, 
          city  : values?.prov_city,
          state : values?.prov_state,
          zipcode : values?.prov_zip,
          id:item.id 

        };
  
        console.log("newproviderpayload", newproviderpayload);
  
          // await createBillingProvider(newproviderpayload);

            await editProvider({
                ...newproviderpayload
                });
  
}


    let payload = {
     ...values,
   enroll_type:"1500",
   id: item.id,
    };

    console.log('payload',payload);
    

     const res = await AddBillingProviderEnrollment(payload);

     console.log('res',res);
     
     if(res?.data?.billingProviderEnrollment?.link){
    
    const url = res.data.billingProviderEnrollment.link[0].url;
  // window.open(url, '_blank'); 

setIFrameUrl(url)

     }
     
     setLoading(false)
await  getBillingProvider({page: 1});

  };

  const handleClose = () => {
    // setIsPreview(false);
    setEditProviderEnrollmentrModalOpen(false);
     setIFrameUrl(null)
     form.reset()
  };

  return (
    <Modal
      opened={EditProviderEnrollmentModalOpen}
      onClose={handleClose}
      title="Provider Enrollment"
      size={700}
      radius={"md"}
      zIndex={1000}
      centered
      styles={{
        title: {
          color: "#000",
          fontSize: "24px",
          fontWeight: "700",
        },
      }}
    >
      <Box className={classes.mainbox}>


{!iframeurl ? <>

        <Text
          style={{ marginBottom: "9px", marginTop: "16px" }}
          ff={"Inter"}
          fz={16}
          fw={600}
          color="#171717"
        >
          Provider Information
        </Text>
        <Box className={classes.addbox}>
          <form>
            <Box className={classes.addbox}>
              <div className={classes.formRow}>
                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Provider first Name
                  </Text>

                  {/* medication name */}
                  <CustomTextInput
                    id="medication-name"
                    // label={"Facility Name"}
                    disabled={isPreview}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                    {...form.getInputProps("prov_name_f")}
                  />
                </Box>

                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Provider middle Name
                  </Text>

                  {/* medication name */}
                  <CustomTextInput
                    id="medication-name"
                    // label={"Facility Name"}
                    disabled={isPreview}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                    {...form.getInputProps("prov_name_m")}
                  />
                </Box>

                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Provider last Name
                  </Text>

                  {/* medication name */}
                  <CustomTextInput
                    id="medication-name"
                    // label={"Facility Name"}
                    disabled={isPreview}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                    {...form.getInputProps("prov_name_l")}
                  />
                </Box>
              </div>

              <div className={classes.formRow}>
                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Provider NpI
                  </Text>

                  {/* medication name */}
                  <CustomTextInput
                    id="medication-name"
                    // label={"Facility Name"}
                    disabled={isPreview}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                    {...form.getInputProps("prov_npi")}
                  />
                </Box>

                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Provider TaxId
                  </Text>

                  {/* medication name */}
                  <CustomTextInput
                    id="medication-name"
                    // label={"Facility Name"}
                    disabled={isPreview}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                    {...form.getInputProps("prov_taxid")}
                  />
                </Box>
              </div>


              <Box className={classes.mt19} mt={10}>
                        <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Payer Id
                  </Text>
      <CustomSelectBox
                    id="billing-type"
                    placeholder={"Select Payer"}
                    withAsterisk
                    limit={10}
                    searchable
                    data={(allpayer && allpayer?.payer
                      ? allpayer?.payer
                      : []
                    ).map((item) => ({
                      value: item.payerId,
                      label: item?.payerName,
                    }))}
                         {...form.getInputProps("payerid")}
                    // {...form.getInputProps("payerEntity")}
                  />
</Box>

              <Box className={classes.mt19} mt={10}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Address 1
                </Text>

                {/* medication name */}
                <CustomTextInput
                  id="medication-name"
                  // label={"Facility Name"}
                  size="sm"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  {...form.getInputProps("prov_addr_1")}
                  disabled={isPreview}
                  withAsterisk
                  // disabled={isPreview}
                />
              </Box>

              <Box className={classes.mt19} mt={10}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Address 2
                </Text>

                {/* medication name */}
                <CustomTextInput
                  id="medication-name"
                  // label={"Facility Name"}
                  size="sm"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  {...form.getInputProps("prov_addr_2")}
                  disabled={isPreview}
                  withAsterisk
                  // disabled={isPreview}
                />
              </Box>

              <div style={{ marginTop: "19px" }} className={classes.formRow}>
                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    City
                  </Text>

                  {/* medication name */}
                  <CustomTextInput
                    id="medication-name"
                    // label={"Facility Name"}
                    {...form.getInputProps("prov_city")}
                    disabled={isPreview}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                  />
                </Box>

                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    State
                  </Text>

                  <CustomSelectBox
                    id="state"
                    size="sm"
                    withAsterisk
                    disabled={isPreview}
                    data={Array.from(
                      new Set(stateZipCodes?.map((obj) => obj.ste_name))
                    )
                      .sort()
                      .map((ste_name) => ({
                        value: ste_name,
                        label: ste_name,
                      }))}
                    {...form.getInputProps("prov_state")}
                    searchable
                  />
                </Box>
              </div>

              <div style={{ marginTop: "19px" }} className={classes.formRow}>
                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Zip Code
                  </Text>

                  <CustomTextInput
                    id="zip-code"
                    type="number"
                    disabled={isPreview}
                    // label={"Facility Name"}
                    {...form.getInputProps("prov_zip")}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                  />
                </Box>
              </div>
            </Box>
          </form>
        </Box>

        <Box className={classes.mainbtn}>
          <Button
            onClick={handleClose}
            variant="fixed"
            c="#1D2939"
            radius="md"
            size="md"
            bg={"#F9FAFB"}
            style={{
              borderRadius: "8px",
              border: " 1px solid  #D0D5DD",
            }}
          >
            Cancel
          </Button>
          <Button
            // type="submit"
            onClick={onSave}
            disabled={isPreview}
            loading={loading}
            variant="filled"
            c="#000"
            radius="md"
            size="md"
            color="yellow"
          >
            Submit
          </Button>
        </Box></> : null}



{iframeurl ? (
  <>
    <iframe
      src={iframeurl}
      width="100%"
      height="500px"
      style={{ border: 'none' }}
      onLoad={() => setLoaded(true)}
    />
  </>
) : null}

      </Box>
    </Modal>
  );
};

export default ProviderEnrollment;
